"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemRedirect = ItemRedirect;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_router_dom_1 = require("react-router-dom");
var letsachieve_1 = require("../../../../api/letsachieve");
var pageHeader_1 = require("../../../../components/pageHeader");
var constants_1 = require("./constants");
function ItemRedirect() {
    var item_id = (0, react_router_dom_1.useParams)().item_id;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, letsachieve_1.useGetItemQuery)(item_id !== null && item_id !== void 0 ? item_id : "", { skip: !item_id }), item = _a.data, isLoading = _a.isLoading, isError = _a.isError;
    var hasTypePage = Boolean(item && constants_1.itemTypeOptions.some(function (option) { return option.key === item.type; }));
    if (isLoading)
        return (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "lg" });
    if (hasTypePage)
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: (0, constants_1.itemPagePath)(item.type, item.id), replace: true });
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center justify-center gap-4 py-16", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:alert-circle", className: "text-4xl text-danger" }), (0, jsx_runtime_1.jsx)("p", { className: "text-lg font-semibold", children: isError || !item ? "This item could not be loaded." : "This item type has no page yet." }), (0, jsx_runtime_1.jsx)(pageHeader_1.BackButton, { label: "Back to items", on_press: function () { return navigate((0, constants_1.itemsListPath)()); } })] }));
}
